<template>
  <div :class="classes">
    <div class="input-group input-group-booking-detail input-height">
      <label class="control-label">{{ label }}</label>
      <div class="input-height input-container" :style="fieldType === 'textarea' ? 'flex-direction: column; justify-content: center;' : null">
        <textarea
          v-if="fieldType === 'textarea'"
          v-model="validations.$model"
          :name="field"
          :type="fieldType"
          :placeholder="placeholder"
          class="form-control"
          style="width: 100%;"
          :rows="rows"/>
        <selectize
          v-else-if="fieldType === 'select'"
          class="selectize selectize-single"
          style="width: 100%;"
          :name="field"
          v-model="validations.$model"
          :options="options">
        </selectize>
        <selectize
          v-else-if="fieldType === 'multi-select-options'"
          class="selectize selectize-multiple selectize-bordered"
          multiple
          style="width: 100%;"
          :name="field"
          v-model="validations.$model"
          :options="options">
        </selectize>
        <booking-field-opportunity-types v-else-if="fieldType === 'multi-select'" v-model="validations.$model" :type="field" :types="multiSelectTypes" :booking="booking" :property-mutator="propertyMutator"/>
        <input
          v-else
          v-model="validations.$model"
          :name="field"
          :type="fieldType"
          :placeholder="placeholder"
          class="form-control"/>
        <slot name="after-info"/>
      </div>
      <vuelidate-help :field="validations" :label="label" />
      <div v-if="(fieldType === 'select' || fieldType === 'multi-select-options') && otherSelected" :class="otherClasses" style="margin-top: 10px">
        <label class="control-label">* {{ otherLabel }}</label>
        <div class="input-height input-container">
          <input
            v-model="otherValidations.$model"
            :name="otherField"
            type="text"
            placeholder="Other Details..."
            class="form-control"/>
        </div>
        <vuelidate-help :field="otherValidations" :label="otherLabel" />
      </div>
    </div>
  </div>
</template>

<script>
import Selectize from '../ext/codium/CodiumSelectize'
import { BookingStateMapper as stateMapper } from 'pickstar-common'
import BookingFieldOpportunityTypes from './BookingFieldOpportunityTypes'
import VuelidateHelp from './VuelidateHelp'

export default {
  mixins: [stateMapper],

  components: {
    BookingFieldOpportunityTypes,
    VuelidateHelp,
    Selectize
  },

  data () {
    return {
      editing: true
    }
  },

  props: {
    validations: {
      required: false
    },
    otherValidations: {
      required: false
    },
    placeholder: {
      required: false
    },
    field: {
      required: true,
      type: String
    },
    value: {
      required: false
    },
    label: {
      required: true,
      type: String
    },
    fieldType: {
      required: false,
      default: 'text',
      type: String
    },
    rows: {
      required: false,
      default: 6,
      type: Number
    },
    options: {
      required: false,
      default: () => { return [] },
      type: Array
    },
    classes: {
      required: false,
      default: '',
      type: String
    },
    otherClasses: {
      required: false,
      default: '',
      type: String
    },
    multiSelectTypes: {
      required: false,
      default: null,
      type: Array
    },
    preText: {
      required: false,
      default: null,
      type: String
    },
    postText: {
      required: false,
      default: null,
      type: String
    },
    highlight: {
      required: false,
      default: false,
      type: Boolean
    },
    booking: {
      required: true,
      type: Object
    },
    propertyMutator: {
      required: true,
      type: Function
    },
    editable: {
      required: false,
      default: true
    },
    type: {
      required: false,
      default: ''
    },
    otherField: {
      required: false,
      default: null
    },
    currency: {
      required: false,
      default: false
    }
  },

  computed: {
    localField: {
      get () {
        return this.booking[this.field]
      },
      set (value) {
        this.propertyMutator({
          property: this.field,
          value
        })
      }
    },

    otherSelected () {
      return this.localField === 'Other' || (this.fieldType === 'multi-select-options' &&
        this.localField.findIndex(item => item === 'Other Marketing Materials') !== -1)
    },

    otherLabel () {
      return this.localField === 'Other' ? 'Other Stage' : 'Other Distribution'
    }
  }
}
</script>

<style scoped lang="scss">
  .input-container {
    display: flex;
    justify-content: space-between;
    align-items: center
  }
  .input-label {
    max-width: 100px;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap
  }
  .input-highlight {
    background-color: var(--brand-primary) !important;
  }
  .highlight-text {
    color: var(--brand-primary) !important;
    font-weight: 700;
    font-size: 18px;
  }
  .input-group-booking-detail {
    box-shadow: none;
  }
</style>
